import React from 'react';
import useInactivityLogout from '../hooks/useInactivityLogout';
import InactivityWarning from './InactivityWarning';

const InactivityWrapper = ({ children }) => {
  // Configurar logout automático después de 30 minutos de inactividad
  const { extendSession } = useInactivityLogout(30);
  
  return (
    <>
      <InactivityWarning onExtend={extendSession} />
      {children}
    </>
  );
};

export default InactivityWrapper;
